<div class="col-md-12 mb-30" [hidden]="Data_Seleted_Record.form_id>0 || Selected_History_Record.makerId>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Inbox</h5>
      <br />
      <br />
      <div class="row">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Letter Subject</label>
          <select class="custom-select" [(ngModel)]="Form_Filter">
            <option value="0">All</option>
            <option *ngFor="let item of DataList_Form" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Request Number</label>
          <input [(ngModel)]="LetterNumber_Filter" name="LetterNumber_Filter" type="number" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Requester</label>
          <input [(ngModel)]="Fullname_Filter" name="Fullname_Filter" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>
      
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Paper()" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Request Number</th>
              <th>Request Type</th>
              <th>Requester</th>
              <th>Request Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Paper
            |filter:Fullname_Filter:'submitName'
          | paginate
                  : {
                      id: 'DataList_FeildTable',
                      itemsPerPage: 10,
                      currentPage: page,
                      totalItems: (DataList_Paper|filter:Fullname_Filter:'submitName').length
                    }
          " [ngClass]="{'DeviceBazgashtAll': item.lastSection_Id===25,'DeviceBazgasht': item.bazgasht===true}">
              <td>
                <p >{{DataList_Paper.indexOf(item)+1}}</p>
                <span *ngIf="!item.visible" class="badge badge-pill badge-info float-right mt-1">New</span>
              </td>
              <td>{{item.uniCode}}</td>
              <td>{{item.title}}</td>
              <td>{{item.submitName}}</td>
              <td>{{item.submitDate}}</td>    
              <td>
                <div class="btn-group " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" (click)="Set_Data_Seleted_Record(item)" class="dropdown-item"><i class="fa fa-eye"></i> View
                      </a>
                      <a href="{{BaseUrl1}}{{item.flochart_id}}{{BaseUrlCo}}{{item.makerId}}"  target="_blank" class="dropdown-item"><i
                        class="fa fa-wpbeginner"></i>
                      Workflow
                    </a>
                    <a style="cursor: pointer;" (click)="ReadData_History(item)" class="dropdown-item"><i class="fa fa-history"></i>
                    Workflow History
                    </a>
                    </div>
                  </div>

                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<div class="col-md-12 mb-30" *ngIf="Data_Seleted_Record.form_id==1">
  <app-PersonOffDayView
    [inner_offday_id]="Data_Seleted_Record.main_id">
    
  </app-PersonOffDayView>

  <img *ngIf="ProcssingAction" src="assets/Loading.gif" style="width: 25px;" />
  <ng-container *ngFor="let item of Data_Seleted_Record.flowchart_edget">
    <button *ngIf="!ProcssingAction" (click)="Show_Data_Seleted_Record(templateAction,item)" type="button" class="btn" [ngStyle]="{'background-color': item.myColor,'margin-left':'10px'}" ><i class="{{item.myIcon}}"></i> {{item.title}} </button>
  </ng-container>
  <button *ngIf="!ProcssingAction" (click)="Reset_Data_Seleted_Record()" type="button" class="btn btn-warning" style="margin-left: 10px;"><i class="fa fa-mail-reply"></i> Back </button>
</div>

<div class="col-md-12 mb-30" *ngIf="Data_Seleted_Record.form_id==2">
  <app-ProductRequestView
    [inner_ProductRequest_id]="Data_Seleted_Record.main_id">
    
  </app-ProductRequestView>

  <img *ngIf="ProcssingAction" src="assets/Loading.gif" style="width: 25px;" />
  <ng-container *ngFor="let item of Data_Seleted_Record.flowchart_edget">
    <button *ngIf="!ProcssingAction" (click)="Show_Data_Seleted_Record(templateAction,item)" type="button" class="btn" [ngStyle]="{'background-color': item.myColor,'margin-left':'10px'}" ><i class="{{item.myIcon}}"></i> {{item.title}} </button>
  </ng-container>
  <button *ngIf="!ProcssingAction" (click)="Reset_Data_Seleted_Record()" type="button" class="btn btn-warning" style="margin-left: 10px;"><i class="fa fa-mail-reply"></i> Back </button>
</div>

<div class="col-md-12 mb-30" *ngIf="Data_Seleted_Record.form_id==3">
  <app-PersonOffTimeView
    [inner_offtime_id]="Data_Seleted_Record.main_id">
    
  </app-PersonOffTimeView>

  <img *ngIf="ProcssingAction" src="assets/Loading.gif" style="width: 25px;" />
  <ng-container *ngFor="let item of Data_Seleted_Record.flowchart_edget">
    <button *ngIf="!ProcssingAction" (click)="Show_Data_Seleted_Record(templateAction,item)" type="button" class="btn" [ngStyle]="{'background-color': item.myColor,'margin-left':'10px'}" ><i class="{{item.myIcon}}"></i> {{item.title}} </button>
  </ng-container>
  <button *ngIf="!ProcssingAction" (click)="Reset_Data_Seleted_Record()" type="button" class="btn btn-warning" style="margin-left: 10px;"><i class="fa fa-mail-reply"></i> Back </button>
</div>

<div class="col-md-12 mb-30" *ngIf="Data_Seleted_Record.form_id==4">
  <app-ScheduleLetterModirView
    [inner_schedule_id]="Data_Seleted_Record.main_id">
    
  </app-ScheduleLetterModirView>

  <img *ngIf="ProcssingAction" src="assets/Loading.gif" style="width: 25px;" />
  <ng-container *ngFor="let item of Data_Seleted_Record.flowchart_edget">
    <button *ngIf="!ProcssingAction" (click)="Show_Data_Seleted_Record(templateAction,item)" type="button" class="btn" [ngStyle]="{'background-color': item.myColor,'margin-left':'10px'}" ><i class="{{item.myIcon}}"></i> {{item.title}} </button>
  </ng-container>
  <button *ngIf="!ProcssingAction" (click)="Reset_Data_Seleted_Record()" type="button" class="btn btn-warning" style="margin-left: 10px;"><i class="fa fa-mail-reply"></i> Back </button>
</div>

<div class="col-md-12 mb-30" *ngIf="Data_Seleted_Record.form_id==5">
  <app-DeviceBehfaRefView
    [inner_behfa_id]="Data_Seleted_Record.main_id">
    
  </app-DeviceBehfaRefView>

  <img *ngIf="ProcssingAction" src="assets/Loading.gif" style="width: 25px;" />
  <ng-container *ngFor="let item of Data_Seleted_Record.flowchart_edget">
    <button *ngIf="!ProcssingAction" (click)="Show_Data_Seleted_Record(templateAction,item)" type="button" class="btn" [ngStyle]="{'background-color': item.myColor,'margin-left':'10px'}" ><i class="{{item.myIcon}}"></i> {{item.title}} </button>
  </ng-container>
  <button *ngIf="!ProcssingAction" (click)="Reset_Data_Seleted_Record()" type="button" class="btn btn-warning" style="margin-left: 10px;"><i class="fa fa-mail-reply"></i> Back </button>
</div>

<div class="col-md-12 mb-30" *ngIf="Data_Seleted_Record.form_id==6">
  <app-DataEntityDeviceInfoView
    [inner_deivce_id]="Data_Seleted_Record.main_id">
    
  </app-DataEntityDeviceInfoView>

  <img *ngIf="ProcssingAction" src="assets/Loading.gif" style="width: 25px;" />
  <ng-container *ngFor="let item of Data_Seleted_Record.flowchart_edget">
    <button *ngIf="!ProcssingAction" (click)="Show_Data_Seleted_Record(templateAction,item)" type="button" class="btn" [ngStyle]="{'background-color': item.myColor,'margin-left':'10px'}" ><i class="{{item.myIcon}}"></i> {{item.title}} </button>
  </ng-container>
  <button *ngIf="!ProcssingAction" (click)="Reset_Data_Seleted_Record()" type="button" class="btn btn-warning" style="margin-left: 10px;"><i class="fa fa-mail-reply"></i> Back </button>
</div>

<div class="col-md-12 mb-30" *ngIf="Data_Seleted_Record.form_id==7">
  <app-CalibrationRequestToExit
    [inner_deivce_id]="Data_Seleted_Record.main_id">
    
  </app-CalibrationRequestToExit>

  <img *ngIf="ProcssingAction" src="assets/Loading.gif" style="width: 25px;" />
  <ng-container *ngFor="let item of Data_Seleted_Record.flowchart_edget">
    <button *ngIf="!ProcssingAction" (click)="Show_Data_Seleted_Record(templateAction,item)" type="button" class="btn" [ngStyle]="{'background-color': item.myColor,'margin-left':'10px'}" ><i class="{{item.myIcon}}"></i> {{item.title}} </button>
  </ng-container>
  <button *ngIf="!ProcssingAction" (click)="Reset_Data_Seleted_Record()" type="button" class="btn btn-warning" style="margin-left: 10px;"><i class="fa fa-mail-reply"></i> Back </button>
</div>

<div class="col-md-12 mb-30" *ngIf="Data_Seleted_Record.form_id==8">
  <app-CalibrationInPositionRequestStatus
    [inner_calibration_id]="Data_Seleted_Record.main_id">
    
  </app-CalibrationInPositionRequestStatus>

  <img *ngIf="ProcssingAction" src="assets/Loading.gif" style="width: 25px;" />
  <ng-container *ngFor="let item of Data_Seleted_Record.flowchart_edget">
    <button *ngIf="!ProcssingAction" (click)="Show_Data_Seleted_Record(templateAction,item)" type="button" class="btn" [ngStyle]="{'background-color': item.myColor,'margin-left':'10px'}" ><i class="{{item.myIcon}}"></i> {{item.title}} </button>
  </ng-container>
  <button *ngIf="!ProcssingAction" (click)="Reset_Data_Seleted_Record()" type="button" class="btn btn-warning" style="margin-left: 10px;"><i class="fa fa-mail-reply"></i> Back </button>
</div>

<div *ngIf="Selected_History_Record.makerId>0" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">Request Workflow History '{{Selected_History_Record.uniCode}}' </h5>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">
            <app-FlowchartHistory [DataList_History]="DataList_History"></app-FlowchartHistory>
          </div>
          <button *ngIf="!InProccessing && canDeleteHistoryRecord && DataList_Peyvast.length==1" type="button" (click)="DeleteLetterHistoryRecord()" class="btn btn-danger"><i class="fa fa-remove"></i>Delete Last Referral</button>
        </div>


      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
    </button>
  </div>
  
</div>


<ng-template #templateAction>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Respond to Request </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Action.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input type="text" class="form-control" [(ngModel)]="PaperDsc" placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button"  class="btn" (click)="Inbox_Action()" [ngStyle]="{'background-color': Data_Seleted_Button.myColor,'margin-left':'10px'}" ><i class="{{Data_Seleted_Button.myIcon}}"></i> {{Data_Seleted_Button.title}} </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Action.hide()">Close</button>
  </div>
</ng-template>